import { ITopupSelectedData } from "@/app/interfaces/ITopup"
import { FC, useEffect, useMemo, useState } from "react"
import { TOPUP_STEP } from "../topup.constant"
import { useRouter } from "next/router"

interface TopupTabProps {
  currentStep: number
  selectedData: ITopupSelectedData
  listStep: any
}

export const TopupDetailTab: FC<TopupTabProps> = ({
  currentStep,
  selectedData,
  listStep
}) => {
  const [percent, setPercent] = useState(0)
  const router = useRouter()

  const renderCheckStep = (step: number) => {
    if (step === TOPUP_STEP.CONFIRM_ID) {
      if (
        selectedData.selectServer.server_id &&
        selectedData.selectRole.role_id
      ) {
        return (
          <div className="w-[27px] h-[27px] border border-[3px] border-bg-light dark:border-bg-02 bg-main-01 rounded-[24px] flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M13.8593 4.2186L6.17968 12.5143C6.1351 12.5625 6.08217 12.6007 6.0239 12.6268C5.96563 12.6529 5.90317 12.6663 5.8401 12.6663C5.77702 12.6663 5.71456 12.6529 5.65629 12.6268C5.59802 12.6007 5.54509 12.5625 5.50051 12.5143L2.14066 8.88492C2.0506 8.78763 2 8.65568 2 8.5181C2 8.38051 2.0506 8.24856 2.14066 8.15127C2.23072 8.05398 2.35288 7.99933 2.48025 7.99933C2.60761 7.99933 2.72977 8.05398 2.81983 8.15127L5.8401 11.4145L13.1802 3.48495C13.2702 3.38766 13.3924 3.33301 13.5198 3.33301C13.6471 3.33301 13.7693 3.38766 13.8593 3.48495C13.9494 3.58224 14 3.71419 14 3.85178C14 3.98936 13.9494 4.12131 13.8593 4.2186Z"
                fill="#FAF8FF"
              />
            </svg>
          </div>
        )
      } else {
        return (
          <div className="w-[27px] h-[27px] border border-[3px] border-bg-light dark:border-bg-02 dark:bg-neutral-07 bg-neutral-09 rounded-[24px] flex items-center justify-center text-[14px] text-main-white">
            {step}
          </div>
        )
      }
    }

    if (step === TOPUP_STEP.PACKAGE_METHOD && step === currentStep) {
      return (
        <div className="w-[27px] h-[27px] border border-[3px] border-bg-light dark:border-bg-02 bg-main-01 rounded-[24px] flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M13.8593 4.2186L6.17968 12.5143C6.1351 12.5625 6.08217 12.6007 6.0239 12.6268C5.96563 12.6529 5.90317 12.6663 5.8401 12.6663C5.77702 12.6663 5.71456 12.6529 5.65629 12.6268C5.59802 12.6007 5.54509 12.5625 5.50051 12.5143L2.14066 8.88492C2.0506 8.78763 2 8.65568 2 8.5181C2 8.38051 2.0506 8.24856 2.14066 8.15127C2.23072 8.05398 2.35288 7.99933 2.48025 7.99933C2.60761 7.99933 2.72977 8.05398 2.81983 8.15127L5.8401 11.4145L13.1802 3.48495C13.2702 3.38766 13.3924 3.33301 13.5198 3.33301C13.6471 3.33301 13.7693 3.38766 13.8593 3.48495C13.9494 3.58224 14 3.71419 14 3.85178C14 3.98936 13.9494 4.12131 13.8593 4.2186Z"
              fill="#FAF8FF"
            />
          </svg>
        </div>
      )
    }

    return (
      <div className="w-[27px] h-[27px] border border-[3px] border-bg-light dark:border-bg-02 dark:bg-neutral-07 bg-neutral-09 rounded-[24px] flex items-center justify-center text-[14px] text-main-white">
        {step}
      </div>
    )
  }

  useEffect(() => {
    if (selectedData.selectUser.user_id) {
      setPercent(15)
    }
    if (
      selectedData.selectServer.server_id &&
      selectedData.selectRole.role_id
    ) {
      setPercent(40)
    }
    if (selectedData.selectPackage.v3_id && selectedData.selectMethod.key) {
      setPercent(75)
    }
  }, [selectedData])

  useEffect(() => {
    setPercent(0)
  }, [router])

  return (
    <div className="md:flex max-w-[420px] w-full mx-auto justify-between relative hidden">
      <div className="bg-neutral-09 dark:bg-neutral-07 h-[1.5px] absolute z-1 w-full top-[14px]">
        <div
          className="bg-main-01 h-full"
          style={{
            width: `${percent}%`
          }}
        ></div>
      </div>
      {listStep.map((item: any) => {
        return (
          <div className="relative z-2" key={item.step}>
            {renderCheckStep(item.step)}
            <p
              className={`whitespace-nowrap absolute left-[50%] translate-x-[-50%] translate-y-[-50%] top-[40px] text-[16px] Nunito-600 ${
                currentStep >= item.step
                  ? "text-main-01"
                  : "text-neutral dark:text-neutral-07"
              }`}
            >
              {item.title}
            </p>
          </div>
        )
      })}
    </div>
  )
}
